export const CARDS_BLOCK_15 =  {
  "blockType": "CARDS",
  "blockDesign": "BYOCards",
  "editFormName": "DESIGN_CARD_PANEL",
  "styleProps": {
    "background-color": "#000000",
    "padding": "120px 20px 120px 20px"
  },
  "headings": [
    {
      "text": "Our Leadership Team",
      "styleProps": {
        "text-align": "center",
        "color": "#ffffff",
        "font-size": "3.75rem",
        "line-height": "1",
        "font-weight": "400",
        "font-family-bk": "'Pacifico', cursive",
        "font-family": "'Pacifico', cursive"
      },
      "stylePropsTab": {
        "font-size": "2.25rem",
        "line-height": "2.5rem"
      },
      "stylePropsMob": {
        "font-size": "1.875rem",
        "line-height": "2.25rem"
      }
    },
    {
      "text": "Meet the visionaries behind our company:",
      "styleProps": {
        "color": "#999999",
        "font-size": "1.5rem",
        "line-height": "2rem",
        "margin": "30px 0px 80px 0px",
        "text-align": "center"
      },
      "stylePropsTab": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "margin": "30px 0px 60px 0px"
      },
      "stylePropsMob": {
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "margin": "30px 0px 40px 0px"
      }
    }
  ],
  "cardElements": [
    {
      "type": "text",
      "id": 1746529638292,
      "elIndex": 0,
      "text": "[[name]]",
      "location": "B",
      "params": [
        {
          "value": "name",
          "label": "name"
        }
      ],
      "styleProps": {
        "color": "#333333",
        "font-size": "3rem",
        "line-height": "1",
        "font-weight": "400",
        "font-family-bk": "'Pacifico', cursive",
        "font-family": "'Pacifico', cursive",
        "font-family-cust": "",
        "padding": "0px 0px 0px 0px"
      },
      "stylePropsTab": {
        "font-size": "1.875rem",
        "line-height": "2.25rem",
        "padding": "0px 0px 0px 0px"
      },
      "stylePropsMob": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "padding": "0px 0px 0px 0px"
      },
      "fonts": {
        "styleProps": ""
      }
    },
    {
      "type": "text",
      "id": 1746531362022,
      "elIndex": 1,
      "text": "[[role]]",
      "location": "B",
      "params": [
        {
          "value": "role",
          "label": "role"
        }
      ],
      "styleProps": {
        "margin": "20px 0px 24px 0px",
        "font-size": "1.5rem",
        "line-height": "2rem",
        "color": "#333333",
        "font-weight": "500",
        "text-align": "left"
      },
      "stylePropsTab": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "margin": "0px 0px 14px 0px"
      },
      "stylePropsMob": {
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "margin": "0px 0px 8px 0px"
      }
    },
    {
      "type": "text",
      "id": 1746533060416,
      "elIndex": 2,
      "text": "[[department]]",
      "location": "B",
      "params": [
        {
          "value": "department",
          "label": "department"
        }
      ],
      "styleProps": {
        "padding": "0px 0px 20px 0px",
        "text-align": "center",
        "color": "#6b6b6b",
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "font-weight": "500"
      },
      "stylePropsTab": {
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "padding": "0px 0px 10px 0px"
      },
      "stylePropsMob": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "padding": "0px 0px 8px 0px"
      }
    },
    {
      "type": "text",
      "id": 1746623025663,
      "elIndex": 3,
      "text": "[[description]]",
      "location": "B",
      "params": [
        {
          "value": "description",
          "label": "description"
        }
      ],
      "styleProps": {
        "text-align": "left"
      }
    }
  ],
  "cardConfig": {
    "perRow": {
      "mobile": 1,
      "tab": 1,
      "desktop": 3
    },
    "layout": "l5",
    "cardstyleProps": {
      "padding": "12px 8px 12px 8px"
    },
    "cardstylePropsTab": {
      "padding": "40px 8px 8px 8px"
    },
    "cardstylePropsMob": {
      "padding": "30px 0px 14px 0px"
    }
  },
  "configs": {
    "dataType": "dynamic",
    "connection": {
      "spreadsheetId": "",
      "sheetName": "",
      "connectionId": "",
      "connectionTable": "",
      "timestamp": 1746627540786
    },
    "params": [],
    "filters": {
      "categories": []
    },
    "searchConfig": {
      "showSearchBar": false,
      "searchButton": {
        "styleProps": {
          "color": "#ffffff",
          "padding": "5px 20px 5px 20px",
          "background-color": "#333333",
          "border-radius": "1.5rem",
          "margin": "0px 10px 0px 10px",
          "font-weight": "bold",
          "width": "auto"
        },
        "stylePropsMob": {
          "width": "auto"
        }
      },
      "clearButton": {
        "styleProps": {
          "background-color": "#ececec",
          "color": "#333333",
          "padding": "5px 20px 5px 20px",
          "border-radius": "9999px"
        }
      },
      "searchContainer": {
        "styleProps": {
          "background-color": "#ececec",
          "border-radius": "1.5rem",
          "padding": "10px 20px 10px 10px",
          "margin": "30px 0px 30px 0px",
          "width": "auto"
        },
        "stylePropsTab": {
          "border-radius": "9999px"
        },
        "stylePropsMob": {
          "border-radius": "1rem",
          "width": "100%"
        }
      },
      "input": {
        "styleProps": {
          "border-radius": "9999px",
          "padding": "5px 20px 5px 20px",
          "color": "#333333",
          "font-weight": "100",
          "background-color": "#ffffff",
          "width": "auto"
        },
        "stylePropsMob": {
          "margin": "0px 0px 10px 0px",
          "width": "100%"
        }
      }
    },
    "sortBy": {
      "columnName": "",
      "ascending": true
    },
    "id": "1723883803066"
  },
  "metaDataId": 1746626748821,
  "afterIndex": 14,
  "blockId": 1746626748821,
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  },
  "cardLocations": [
    {
      "name": "outer",
      "styleProps": {
        "background-image": "url('')",
        "border-radius": "0px",
        "padding": "20px 20px 20px 20px",
        "background-repeat": "no-repeat",
        "background-size": "cover",
        "background-color": "#ffffff",
        "box-shadow": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)"
      },
      "stylePropsTab": {
        "padding": "15px 14px 15px 14px"
      },
      "stylePropsMob": {
        "padding": "14px 14px 14px 14px"
      }
    },
    {
      "name": 0
    },
    {
      "name": "A",
      "styleProps": {
        "background-color": "#ffffff",
        "margin": "0px 0px 0px 0px",
        "border-radius": "0px",
        "padding": "20px 26px 20px 26px",
        "box-shadow": "",
        "alignItems": "center",
        "justify-content": "center",
        "flex-direction": "column",
        "display": "flex",
        "width": "100%",
        "text-align": "center",
        "background-image": "url('[[img]]')",
        "background-repeat": "no-repeat",
        "background-position": "center",
        "background-size": "cover"
      },
      "stylePropsTab": {
        "padding": "20px 26px 20px 26px"
      },
      "stylePropsMob": {
        "padding": "20px 20px 20px 20px"
      },
      "innerDiv": {
        "styleProps": {
          "height": "256px"
        }
      }
    },
    {
      "name": "B",
      "styleProps": {
        "padding": "30px 30px 30px 30px",
        "display": "flex",
        "flex-direction": "column",
        "justify-content": "",
        "width": "100%",
        "alignItems": "",
        "text-align": "left"
      },
      "innerDiv": {
        "styleProps": {
          "justify-content": "left",
          "alignItems": "flex-start",
          "height": "256px"
        },
        "stylePropsMob": {
          "height": "170px"
        }
      },
      "stylePropsTab": {
        "padding": "20px 20px 30px 20px"
      },
      "stylePropsMob": {
        "padding": "21px 21px 21px 21px"
      }
    },
    {
      "name": "C",
      "styleProps": {
        "width": "100%",
        "display": "flex",
        "flex-direction": "row",
        "alignItems": "center",
        "justify-content": "center",
        "text-align": "center"
      },
      "innerDiv": {
        "styleProps": {
          "width": "100%",
          "display": "flex",
          "flex-direction": "row",
          "alignItems": "center",
          "justify-content": "flex-end",
          "padding": "20px 20px 20px 20px"
        }
      }
    }
  ],
  "overlay": {
    "styleProps": {
      "background-color": "#"
    }
  },
  "containerStyleProps": {
    "max-width": "1280px"
  }
}